var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text != null)?_c('label',{class:[
    'label-input',
    { 'is-disabled': _vm.disabled === true },
    { 'has-icon': _vm.international === true } ],attrs:{"for":_vm.id}},[(_vm.international === true)?_c('v-icon',{staticClass:"label-input__icon"},[_vm._v("\n    language\n  ")]):_vm._e(),(_vm.text != null)?[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]:_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }